import NonMfaWhatsappPreference from './NonMfaWhatsappPreference';

import {ReactComponent as CheckMark} from '../../assets/svg/checkMark.svg';
import i18n from '../../i18n';
import {
  fetchNonMfaUserProfile,
  nonMfaUserSubmitOffer,
} from '../../redux/actions/actions';
import {submitNonMfaResaleAssetEnquiry} from '../../redux/resale/resale.action';
import {checkNonMfaTokenValidity} from '../../utils/util';
import NonMfaHeader from '../offers/common/offersHeader';
import SkeletonComponent from '../skeleton_component/SkeletonComponent';

import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import './NonMfaSubmittedEnquiry.css';

export function NonMfaSubmittedEnquiry({
  fetchProfile,
  submitOffer,
  submitResaleEnquiry,
  enquirySubmitted,
  resaleEnquirySubmittingStatus,
  selectedAsset,
  showWhatsAppOptIn,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from;
  const isTokenValid = checkNonMfaTokenValidity();
  const isResale = from === 'resaleTractor';
  const redirectTarget = isResale ? '/resale' : '/offerslist';

  const isEnquirySubmitted = isResale
    ? resaleEnquirySubmittingStatus?.status === 'success'
    : enquirySubmitted;

  useEffect(() => {
    if (!isTokenValid) {
      navigate('/', {replace: true});
      return;
    }
    if (!from) {
      navigate('/offerslist', {replace: true});
      return;
    }
    fetchProfile();
    if (isResale) {
      const assetId = selectedAsset && Object.keys(selectedAsset)[0];
      submitResaleEnquiry({assetId});
    } else {
      submitOffer();
    }
  }, []);

  useEffect(() => {
    if (isEnquirySubmitted && !showWhatsAppOptIn) {
      navigate(redirectTarget, {replace: true});
    }
  }, [isEnquirySubmitted]);

  if (!isTokenValid || !from) {
    return null;
  }

  return (
    <div className="nonMfaEnquirySubmittedContainer">
      <NonMfaHeader />
      {!isEnquirySubmitted ? (
        <div className="loading-skelton">
          <SkeletonComponent componentName="NonMfaOffersListLanding" />
        </div>
      ) : (
        <div className="nonMfaSubmitEnquiryContainer">
          <div className="enquiry-submitted-container">
            <CheckMark className="checkMark" />
            <h4 className="enquiry-submitted-text">
              {i18n.t('ENQUIRY_SUBMITTED_SUCCESSFULLY')}
            </h4>
          </div>
          <div>
            <NonMfaWhatsappPreference
              onComplete={() => navigate(redirectTarget)}
            />
          </div>
        </div>
      )}
    </div>
  );
}

NonMfaSubmittedEnquiry.propTypes = {
  fetchProfile: PropTypes.func.isRequired,
  submitOffer: PropTypes.func.isRequired,
  submitResaleEnquiry: PropTypes.func.isRequired,
  enquirySubmitted: PropTypes.bool,
  resaleEnquirySubmittingStatus: PropTypes.shape({
    status: PropTypes.string,
  }),
  selectedAsset: PropTypes.object,
  showWhatsAppOptIn: PropTypes.bool,
};

export const mapStateToProps = (state) => ({
  enquirySubmitted: state?.mfaStates?.nonMfaUserData?.enquirySubmitted,
  resaleEnquirySubmittingStatus: state?.resale?.enquirySubmittingStatus,
  selectedAsset: state?.resale?.resaleItemDetails?.data,
  showWhatsAppOptIn: state?.profile?.profile?.showWhatsAppOptIn,
});

export const mapDispatchToProps = (dispatch) => ({
  fetchProfile: () => dispatch(fetchNonMfaUserProfile()),
  submitOffer: () => dispatch(nonMfaUserSubmitOffer({})),
  submitResaleEnquiry: (enquiryData) =>
    dispatch(submitNonMfaResaleAssetEnquiry(enquiryData)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NonMfaSubmittedEnquiry);
